// 字典数据类型
export interface DictItem {
  key: string // 字典值
  value: string // 字典标签
  [key: string]: any
}

// 字典原始数据结构
export interface DictRawItem {
  dictCode: string
  dictName: string
  detailList: Array<{
    key: string
    value: string
    [key: string]: any
  }>
}

export interface DictData {
  [dictCode: string]: DictItem[]
}

interface State {
  dictData: DictData
  loading: boolean
}

export type ActionType = 'setDictData' | 'getDictData' | 'setDictLoading'

interface Action {
  type: ActionType
  payload?: any
}

const initialState: State = {
  dictData: {},
  loading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDictData':
      newstate.dictData = action.payload || {}
      return newstate
    case 'setDictLoading':
      newstate.loading = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置字典数据
 * @param data 字典数据
 * @returns
 */
export const setDictDataAction = (data: DictData): Action => ({
  type: 'setDictData',
  payload: data,
})

/**
 * 获取字典数据
 * @returns
 */
export const getDictDataAction = (): Action => ({
  type: 'getDictData',
})

/**
 * 设置加载状态
 * @param loading 加载状态
 * @returns
 */
export const setDictLoadingAction = (loading: boolean): Action => ({
  type: 'setDictLoading',
  payload: loading,
})

// 导出工具函数
export * from './utils'
// 字典数据类型
export interface DictItem {
  key: string // 字典值
  value: string // 字典标签
  [key: string]: any
}

// 字典原始数据结构
export interface DictRawItem {
  dictCode: string
  dictName: string
  detailList: Array<{
    key: string
    value: string
    [key: string]: any
  }>
}

export interface DictData {
  [dictCode: string]: DictItem[]
}

interface State {
  dictData: DictData
  loading: boolean
}

export type ActionType = 'setDictData' | 'getDictData' | 'setDictLoading'

interface Action {
  type: ActionType
  payload?: any
}

const initialState: State = {
  dictData: {},
  loading: false,
}

export default function reducer(
  state: State = initialState,
  action: Action,
): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setDictData':
      newstate.dictData = action.payload || {}
      return newstate
    case 'setDictLoading':
      newstate.loading = action.payload
      return newstate
    default:
      return newstate
  }
}

/**
 * 设置字典数据
 * @param data 字典数据
 * @returns
 */
export const setDictDataAction = (data: DictData): Action => ({
  type: 'setDictData',
  payload: data,
})

/**
 * 获取字典数据
 * @returns
 */
export const getDictDataAction = (): Action => ({
  type: 'getDictData',
})

/**
 * 设置加载状态
 * @param loading 加载状态
 * @returns
 */
export const setDictLoadingAction = (loading: boolean): Action => ({
  type: 'setDictLoading',
  payload: loading,
})

// 导出工具函数
export * from './utils'
